(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["naoko-collection-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MQ_REDUCE = '(prefers-reduced-motion: reduce)';

    function activate(video) {
      if (video.dataset.ncvInited) return;
      video.dataset.ncvInited = '1';

      // Reduced motion → zostaje statyczny poster, wideo nie startuje.
      if (window.matchMedia && window.matchMedia(MQ_REDUCE).matches) return;

      var mq = video.dataset.mobileMq || '(max-width: 749px)';
      var isMobile = window.matchMedia && window.matchMedia(mq).matches;
      var src = isMobile
        ? video.dataset.srcMobile || video.dataset.srcDesktop
        : video.dataset.srcDesktop || video.dataset.srcMobile;
      if (!src) return;

      // Pobieramy DOKŁADNIE jedno źródło (desktop ALBO mobile).
      var source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      video.appendChild(source);
      video.load();

      video.addEventListener(
        'playing',
        function () {
          video.classList.add('is-ready');
        },
        { once: true }
      );

      tryPlay(video);
    }

    // ---- Start / wznowienie odtwarzania (Safari) ----
    // Safari odrzuca play() bez gestu (NotAllowedError) przy Autoodtwarzaniu „Nigdy” dla
    // witryny lub trybie niskiego zużycia energii — mimo `muted`. Diagnoza 2026-09-25 na Macu:
    // wideo w pełni pobrane (readyState 4), play() → NotAllowedError. Po odrzuceniu ponawiamy
    // przy PIERWSZYM geście (pointerdown/touchend/keydown/click; scroll nie jest aktywacją).
    // Ten sam mechanizm: assets/naoko-home-tiles.js.
    var GESTURES = ['pointerdown', 'touchend', 'keydown', 'click'];

    function tryPlay(video) {
      video.muted = true;
      video.defaultMuted = true;
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          armGestureRetry(video);
        });
      }
    }

    function armGestureRetry(video) {
      if (video.dataset.ncvGesture) return;
      video.dataset.ncvGesture = '1';
      var retry = function () {
        for (var i = 0; i < GESTURES.length; i++) document.removeEventListener(GESTURES[i], retry, true);
        video.dataset.ncvGesture = '';
        if (video.paused) tryPlay(video);
      };
      for (var i = 0; i < GESTURES.length; i++) {
        document.addEventListener(GESTURES[i], retry, { capture: true, passive: true });
      }
    }

    // bfcache (powrót „wstecz”) i powrót karty z tła: Safari zostawia wideo spauzowane
    // przy ukrytym posterze (is-ready) → zamrożony kadr. Wznawiamy.
    function resumeAll() {
      var videos = document.querySelectorAll('[data-naoko-collection-video][data-ncv-inited="1"]');
      for (var i = 0; i < videos.length; i++) {
        var v = videos[i];
        if (v.paused && !v.ended && v.querySelector('source')) tryPlay(v);
      }
    }
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) resumeAll();
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) resumeAll();
    });

    function schedule(video) {
      // Odraczamy doładowanie wideo, by poster zdążył się namalować (LCP).
      if ('requestIdleCallback' in window) {
        requestIdleCallback(function () { activate(video); }, { timeout: 2500 });
      } else {
        setTimeout(function () { activate(video); }, 250);
      }
    }

    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var videos = scope.querySelectorAll('[data-naoko-collection-video]');
      for (var i = 0; i < videos.length; i++) schedule(videos[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    // Theme editor: ponowne wstrzyknięcie sekcji.
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();

    // Show more / read more toggle
    document.querySelectorAll('[data-show-more-toggle]').forEach(btn => {
      const content = btn.closest('.tab-content, .tab-content')?.querySelector('.toggle-content--height');
      if (!content) return;
      const maxH = parseFloat(getComputedStyle(content).getPropertyValue('--max-height')) || 300;
      if (content.scrollHeight <= maxH) {
        btn.closest('.tab-show-more').style.display = 'none';
        return;
      }
      content.style.maxHeight = maxH + 'px';
      btn.addEventListener('click', () => {
        const isOpen = content.classList.toggle('is-expanded');
        content.style.maxHeight = isOpen ? content.scrollHeight + 'px' : maxH + 'px';
        btn.textContent = isOpen ? btn.dataset.textLess : btn.dataset.textMore;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
